// What the app knows about the Service package for this login. getClientConfig (src/lib/supabase.js) calls withService once. Off / not there: the config
// comes back as the SAME object, with no "service" key, and nothing else in the package runs.
import { hasPackage, packagesOf } from './hasPackage'

export const companyIdOf = cfg => (cfg && (cfg.companyId || cfg.company_id)) || null

export async function withService(cfg, supabase) {
  const companyId = companyIdOf(cfg)
  if (!cfg || !companyId) return cfg
  try {
    const { data, error } = await supabase.from('company_packages').select('package,enabled').eq('company_id', companyId)
    if (error || !hasPackage({ packages: packagesOf(data) }, 'service')) return cfg
    const { data: rows } = await supabase.from('service_vessel_settings').select('client_id,effective_simple').eq('effective_simple', true)
    return { ...cfg, service: { on: true, companyId, simple: (rows || []).map(r => r.client_id) } }
  } catch (e) { return cfg }
}

// the last check in getClientConfig (no other kind of login found): a technician of a company. Never runs for an existing login.
export async function technicianConfig(user, supabase) {
  if (!user) return null
  try {
    const { data: t, error } = await supabase.from('service_technicians').select('id,company_id,company_name,name,email,phone,active').eq('user_id', user.id).maybeSingle()
    if (error || !t) return null
    if (!t.active) return { id: t.id, accountType: 'locked', role: 'locked', companyName: t.company_name, vessel_name: t.company_name }
    const { data } = await supabase.from('company_packages').select('package,enabled').eq('company_id', t.company_id)
    return { id: t.id, accountType: 'technician', role: 'technician', technicianId: t.id, crewName: t.name, companyId: t.company_id, companyName: t.company_name, vessel_name: t.company_name, plan: 'starter', features: {},
      service: { on: hasPackage({ packages: packagesOf(data) }, 'service'), companyId: t.company_id, simple: [] } }
  } catch (e) { return null }
}
